import React from 'react'
import { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import PdfRender from '../PrintPdf/PdfRender'
import SummaryResume from './SummaryResume'

function PrintSummary() {
    const printrender = useRef()
    const handleSummaryResume = useReactToPrint(
        {
            content: () => printrender.current,
            documentTitle: "ResumeSummary"
        }

    )

  return (
    <>
    <div ref={printrender}>
        <SummaryResume/>
        
    </div>
    <button style={{marginLeft:'14.875rem'}}
    onClick={handleSummaryResume}>Print</button>
    </>
  )
}

export default PrintSummary